// Identity Platform (Firebase Auth) client — email-link only. Initialized from
// /api/health features.emailLink.firebase so islands do not need a web rebuild.
import { getApp, getApps, initializeApp, type FirebaseApp } from "firebase/app";
import { getAuth, type Auth } from "firebase/auth";

export const EMAIL_FOR_SIGN_IN_KEY = "emailForSignIn";

export interface FirebaseWebConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
}

function appFor(config: FirebaseWebConfig): FirebaseApp {
  if (getApps().length > 0) return getApp();
  return initializeApp(config);
}

export function getFirebaseAuth(config: FirebaseWebConfig): Auth {
  return getAuth(appFor(config));
}
